function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Sekundarny-trh-6_1_8",
  transform: "translate(-974.000000, -350.000000)",
  stroke: "#262535",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(428.000000, 327.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "x",
  transform: "translate(547.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 0,
  x2: 0,
  y2: 12,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 0,
  x2: 12,
  y2: 12,
  id: "Path"
})))));

var SvgCloseGrey = function SvgCloseGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-grey.c11cffe5.svg";
export { ForwardRef as ReactComponent };